/** estado de CLIENTE/RegistroCuentaBancariaBuscar(PorCliente) */
export enum SpectrumBankAccountStatus {
  ACTIVE = 'A',
  INACTIVE = 'I',
  REJECTED = 'R',
  PENDING = 'P',
}

export const SpectrumBankAccountStatusLabel: Record<SpectrumBankAccountStatus, string> = {
  [SpectrumBankAccountStatus.ACTIVE]: 'Aprobada',
  [SpectrumBankAccountStatus.INACTIVE]: 'Inactiva',
  [SpectrumBankAccountStatus.REJECTED]: 'Rechazada',
  [SpectrumBankAccountStatus.PENDING]: 'Pendiente de aprobar',
}

/** tipoOperacion de CLIENTE/RegistroCuentaBancariaAprobarRechazar */
export enum SpectrumBankAccountOperation {
  APPROVE = 'A',
  REJECT = 'R',
}

export enum SpectrumIdentityTypeEnum {
  OTRO = '00',
  DNI = '01',
  CE = '04',
  RUC = '06',
  PASSPORT = '07',
}

/** tipoMoneda de CLIENTE/RegistroCuentaBancariaBuscar */
export enum SpectrumCurrencyTypeEnum {
  SOLES = '01',
  DOLARES = '02',
}

export const SpectrumCurrencyTypeLabel: Record<SpectrumCurrencyTypeEnum, string> = {
  [SpectrumCurrencyTypeEnum.SOLES]: 'Soles',
  [SpectrumCurrencyTypeEnum.DOLARES]: 'Dólares',
}
